export class Impuesto {
	constructor(
            public id: String = "",
            public codigo: String = "",
			public nombre: String = "",
            public empresa_id: String = "",
            public usuario_id: String = "",
	){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/impuesto.ts